const data = [
	{
		value : "25+",
		title : "Number of Projects"
	},
	{
		value : "6",
		title : "No. of Companies I'm associated with"
	},
	{
		value : "100K+",
		title : "Lines of Code"
	}
]
export default data